/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Settings_Billing_Renews_OnInputs */

const en_settings_billing_renews_on = /** @type {(inputs: Settings_Billing_Renews_OnInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Renews on ${i?.date}`)
};

/**
* | output |
* | --- |
* | "Renews on {date}" |
*
* @param {Settings_Billing_Renews_OnInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_renews_on = /** @type {((inputs: Settings_Billing_Renews_OnInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Renews_OnInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_renews_on(inputs)
});
export { settings_billing_renews_on as "settings.billing.renews_on" }